import { render, staticRenderFns } from "./consuption.vue?vue&type=template&id=779f6506&"
import script from "./consuption.vue?vue&type=script&lang=js&"
export * from "./consuption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports